export default __webpack_public_path__ + "67aef8628970fe7639559bc667bd6248.png";